import btnClasses from "../../../commons/Button.module.scss";
import Text from "../../../commons/Text";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import imgWebp from "../../../../assets/img/landings/nextres/solution.webp";
import imgPng from "../../../../assets/img/landings/nextres/solution.png";
import RequestDemo from "../../../../components/Button/RequestDemo";

export default function Solution({ title, text }) {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.content}>
            <Title title={title} number={"02"} />
            <Text text={text} />
            <RequestDemo className={btnClasses.button} />
          </div>
          <div className={classes.image}>
            <picture>
              <source srcSet={imgWebp} type="image/webp" />
              <source srcSet={imgPng} type="image/png" />
              <img src={imgPng} alt={title} width={561} height={397} />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
}
